<template>
  <div class="popup-box flex flex-column" style="position: relative">
    <ul class="form-box">
      <el-form :model="state.model" ref="formDom">
        <div style="font-weight: 600; font-size: 13px; margin-bottom: 10px">
          基本信息
        </div>
        <div class="info-form">
          <el-form-item label="状态">
            <el-switch
              v-model="state.model.status"
              inline-prompt
              active-text="正常"
              active-color="#1e90ff"
              inactive-text="停用"
              inactive-color="#f00"
              :active-value="1"
              :inactive-value="0"
              style="--el-switch-off-color: #f00"
            />
          </el-form-item>
          <el-form-item
            label="客户名称"
            prop="name"
            :rules="[
              {
                required: true,
                message: '请填写客户名称',
                trigger: 'blur',
              },
            ]"
          >
            <el-input v-model="state.model.name"></el-input>
          </el-form-item>
          <el-form-item
            label="客户简称"
            prop="alias"
            :rules="[
              {
                required: true,
                message: '请填写客户简称',
                trigger: 'blur',
              },
            ]"
          >
            <el-input v-model="state.model.alias"></el-input>
          </el-form-item>
          <el-form-item
            label="客户代码"
            prop="code"
            :rules="[
              {
                required: true,
                message: '请填写客户代码',
                trigger: 'blur',
              },
            ]"
          >
            <el-input v-model="state.model.code"></el-input>
          </el-form-item>
          <el-form-item label="客户类型">
            <el-select
              v-model="state.model.d_customer_type_id"
              placeholder="--客户类型--"
            >
              <el-option
                v-for="item in state.customertypeData"
                :key="item.id"
                :label="item.name"
                :value="item.id"
              />
            </el-select>
          </el-form-item>
          <el-form-item
            label="统一社会信用代码"
            prop="unified_social_credit_identifier"
            :rules="[
              {
                required: true,
                message: '请填写统一社会信用代码',
                trigger: 'blur',
              },
            ]"
          >
            <el-input
              v-model="state.model.unified_social_credit_identifier"
            ></el-input>
          </el-form-item>
          <el-form-item label="所属行业">
            <el-tree-select
              v-model="state.model.d_industry_id"
              :data="state.industryData"
              node-key="id"
              accordion
              :props="{ label: 'name' }"
              :render-after-expand="false"
              :highlight-current="true"
              :default-expand-all="true"
              :check-strictly="true"
              placeholder="--所属行业--"
              filterable
            >
              <template #default="{ data }">
                <div style="display: flex; align-items: center">
                  {{ data.name }}
                </div>
              </template>
              <template #footer>
                <el-button size="small" @click="onLoadIndustry()">
                  刷新
                </el-button>
              </template>
            </el-tree-select>
          </el-form-item>
          <el-form-item label="单位电话">
            <el-input v-model="state.model.phone" type="number"></el-input>
          </el-form-item>
          <el-form-item label="所属地区">
            <el-cascader
              v-model="state.model.area"
              :options="state.areaData"
              :props="{ label: 'name', value: 'name' }"
              placeholder="--所属地区--"
              clearable
              filterable
              @change="onAreaChange"
              style="width: 100%"
            />
          </el-form-item>
          <el-form-item label="所在地址" style="width: 66.66%">
            <el-input v-model="state.model.address"></el-input>
          </el-form-item>
        </div>
        <div style="font-weight: 600; font-size: 13px; margin: 10px 0">
          联系信息
        </div>
        <div class="info-form">
          <el-form-item
            label="对接人姓名"
            prop="contact_name"
            :rules="[
              {
                required: true,
                message: '请填写对接人姓名',
                trigger: 'blur',
              },
            ]"
          >
            <el-input v-model="state.model.contact_name"></el-input>
          </el-form-item>
          <el-form-item label="职位">
            <el-input v-model="state.model.contact_job"></el-input>
          </el-form-item>
          <el-form-item
            label="联系方式"
            prop="contact_phone"
            :rules="[
              {
                required: true,
                message: '请填写联系方式',
                trigger: 'blur',
              },
              {
                validator: phone_rules,
                trigger: 'blur',
              },
            ]"
          >
            <el-input
              v-model="state.model.contact_phone"
              type="number"
            ></el-input>
          </el-form-item>
          <el-form-item label="登录密码">
            <div style="display: flex; align-items: center">
              <el-input
                type="password"
                v-model="state.model.password"
                show-password
              ></el-input>
              <el-icon style="margin-left: 10px" color="#ffa500">
                <QuestionFilled />
              </el-icon>
              <text
                style="color: #ffa500; margin-left: 3px; white-space: nowrap"
                v-if="!props.id"
              >
                密码不少于6位
              </text>
            </div>
          </el-form-item>
          <el-form-item label="确认密码">
            <div style="display: flex; align-items: center">
              <el-input
                type="password"
                v-model="state.model.password_confirm"
                show-password
              ></el-input>
              <el-icon style="margin-left: 10px" color="#ffa500">
                <QuestionFilled />
              </el-icon>
              <text
                style="color: #ffa500; margin-left: 3px; white-space: nowrap"
                v-if="!props.id"
              >
                密码不少于6位
              </text>
            </div>
          </el-form-item>
        </div>
        <div style="font-weight: 600; font-size: 13px; margin: 10px 0">
          业务信息
        </div>
        <div class="info-form">
          <el-form-item
            label="签单时间"
            prop="contract_time"
            :rules="[
              {
                required: true,
                message: '请选择签单时间',
                trigger: 'blur',
              },
            ]"
          >
            <el-date-picker
              v-model="state.model.contract_time"
              type="date"
              value-format="YYYY-MM-DD"
            />
          </el-form-item>
          <el-form-item
            label="客服专员"
            prop="belonger_ids"
            :rules="[
              {
                required: true,
                message: '请选择客服专员',
                trigger: 'blur',
              },
            ]"
          >
            <el-tree-select
              v-model="state.model.belonger_ids"
              :props="{
                value: 'id',
                label: 'name',
                class: 'belonger-tree-class',
              }"
              node-key="id"
              value-key="id"
              placeholder="客服专员"
              :data="state.admin_data"
              default-expand-all
              multiple
              filterable
              clearable
              show-checkbox
              ref="belongerDom"
            >
              <template #default="{ data }">
                <el-icon :size="16" v-if="data.type == 0"
                  ><UserFilled
                /></el-icon>
                <el-icon :size="16" v-else><User /></el-icon>
                <span style="margin-left: 3px">{{ data.name }}</span>
              </template>
            </el-tree-select>
          </el-form-item>
          <el-form-item
            label="签单人"
            prop="signer_id"
            :rules="[
              {
                required: true,
                message: '请选择签单人',
                trigger: 'blur',
              },
            ]"
          >
            <el-tree-select
              v-model="state.model.signer_id"
              :props="{
                value: 'id',
                label: 'name',
                class: 'belonger-tree-class',
              }"
              node-key="id"
              value-key="id"
              placeholder="签单人"
              :data="state.admin_data"
              default-expand-all
              filterable
              clearable
              @current-change="onSignerChange"
            >
              <template #default="{ data }">
                <el-icon :size="16" v-if="data.type == 0"
                  ><UserFilled
                /></el-icon>
                <el-icon :size="16" v-else><User /></el-icon>
                <span style="margin-left: 3px">{{ data.name }}</span>
              </template>
            </el-tree-select>
          </el-form-item>
          <el-form-item
            label="服务类型"
            prop="d_service_id"
            :rules="[
              {
                required: true,
                message: '请选择服务类型',
                trigger: 'blur',
              },
            ]"
          >
            <el-select
              v-model="state.model.d_service_id"
              placeholder="--服务类型--"
            >
              <el-option
                v-for="item in state.serviceData"
                :key="item.id"
                :label="item.name"
                :value="item.id"
              />
              <template #footer>
                <el-button size="small" @click="onLoadService()">
                  刷新
                </el-button>
              </template>
            </el-select>
          </el-form-item>
          <el-form-item
            label="服务费承担方式"
            prop="service_cost_mode"
            :rules="[
              {
                required: true,
                message: '请选择服务费承担方式',
                trigger: 'blur',
              },
            ]"
          >
            <el-radio-group v-model="state.model.service_cost_mode">
              <el-radio-button :value="0">员工</el-radio-button>
              <el-radio-button :value="1">公司</el-radio-button>
            </el-radio-group>
          </el-form-item>
          <el-form-item label="服务费计算方式" style="width: 66.66%">
            <div style="display: flex; align-items: center">
              <el-config-provider
                :value-on-clear="null"
                :empty-values="[undefined, null]"
              >
                <el-select
                  v-model="state.model.service_cost_calc_mode"
                  placeholder="计算基数"
                  style="width: 200px"
                  @change="onServiceCostCalcModeChange"
                >
                  <el-option label="无" :value="0" />
                  <el-option label="应发工资" :value="1" />
                  <el-option label="应发工资-代扣项目" :value="2" />
                </el-select>
                <el-input-number
                  v-model="state.model.service_cost_calc_rate"
                  :controls="false"
                  class="number-input-left number-input-suffix"
                  :precision="2"
                  suffix="%"
                  style="width: 100px; margin-left: 5px"
                  :disabled="!state.model.service_cost_calc_mode"
                ></el-input-number>
                <text style="font-size: 30px; margin-left: 5px; color: #626262">
                  +
                </text>
                <el-select
                  v-model="state.model.service_cost_type"
                  placeholder="收费类型"
                  style="width: 120px; margin-left: 5px"
                  @change="onServiceCostTypeChange"
                >
                  <el-option label="无" :value="0" />
                  <el-option label="每人每月" :value="1" />
                  <el-option label="每人每笔" :value="2" />
                </el-select>
                <el-input-number
                  v-model="state.model.service_cost"
                  :controls="false"
                  class="number-input-left number-input-suffix"
                  :precision="2"
                  suffix="元"
                  style="width: 100px; margin-left: 5px"
                  :disabled="!state.model.service_cost_type"
                ></el-input-number>
              </el-config-provider>
            </div>
          </el-form-item>
        </div>
      </el-form>
    </ul>
    <ul class="submit-box">
      <el-button type="primary" @click="onSubmit">提交</el-button>
    </ul>
    <transition name="el-zoom-in-center">
      <c_popup
        v-if="state.showBelonger"
        title="选择负责人"
        @close="state.showBelonger = false"
      >
        <c_AdminSelect
          @submit="
            (item) => {
              state.model.belonger_id = item.id;
              state.model.belonger = item.name + '/' + item.department_name;
              state.showBelonger = false;
            }
          "
          :id="state.model.belonger_id"
        ></c_AdminSelect>
      </c_popup>
    </transition>
  </div>
</template>

<script>
import { onMounted, reactive, ref } from "vue";
import { data_industry_tree, data_areacode_tree } from "@/http/data";
import { customertype_tree, customerservice_tree } from "@/http/dictionary";
import { admin_cascader } from "@/utils/qFormat";
import { customermine_add, customermine_detail, customermine_edit } from "@/http/customer";
import { post_response } from "@/utils/qFormat";
import { phone_rules, passwordlength_rules } from "@/utils/rules";

export default {
  props: {
    id: Number,
  },
  setup(props, { emit }) {
    const belongerDom = ref(null);
    const formDom = ref(null);
    const state = reactive({
      model: {
        status: 1,
        tax_mode: 0,
      },
    });
    onMounted(() => {
      onLoadCustomeType();
      onLoadIndustry();
      onLoadAreaCode();
      onLoadService();
      onLoadAdmin();

      if (props.id) {
        customermine_detail(props.id).then((res) => {
          if (res.status == 200) {
            const { data } = res.data;
            state.model = data;
            state.model.belonger_ids =
              data.customerBelongerList?.map((m) => m.admin_id) || [];
            if (state.model.district) {
              data.area = [data.province, data.city, data.district];
            }
          }
        });
      }
    });

    //获取客户类型
    const onLoadCustomeType = () => {
      customertype_tree().then((res) => {
        if (res.status == 200) state.customertypeData = res.data.data;
      });
    };

    //获取行业树
    const onLoadIndustry = () => {
      data_industry_tree().then((res) => {
        if (res.status == 200) state.industryData = res.data.data;
      });
    };

    //行政区划
    const onLoadAreaCode = () => {
      data_areacode_tree().then((res) => {
        if (res.status == 200) state.areaData = res.data.data?.list;
      });
    };

    const onAreaChange = (value) => {
      if (value.length == 3) {
        state.model.province = value[0];
        state.model.city = value[1];
        state.model.district = value[2];
      }
    };

    //获取服务类型
    const onLoadService = () => {
      customerservice_tree().then((res) => {
        if (res.status == 200) state.serviceData = res.data.data;
      });
    };

    //获取业务员
    const onLoadAdmin = () => {
      admin_cascader().then((res) => {
        state.admin_data = res;
      });
    };

    //业务员改变事件需要获取其部门id
    const onBelongerChange = (item) => {
      state.model.belonger_department_id = item.pid;
    };

    //业务员改变事件需要获取其部门id
    const onSignerChange = (item) => {
      state.model.signer_department_id = item.pid;
    };

    const onSubmit = () => {
      formDom.value.validate((valid) => {
        if (valid) {
          const belongerArr = belongerDom.value.getCheckedNodes();
          state.model.belonger_data = belongerArr
            .filter((w) => w.type == 1)
            .map((item) => {
              return {
                admin_id: item.id,
                department_id: item.pid,
                is_primary: 0,
              };
            });
          if (props.id) {
            customermine_edit(state.model).then((res) => {
              post_response(res, emit);
            });
          } else {
            customermine_add(state.model).then((res) => {
              post_response(res, emit);
            });
          }
        }
      });
    };

    const onServiceCostCalcModeChange = (value) => {
      if (value) {
        delete state.model.service_cost_calc_rate;
      }
    };

    const onServiceCostTypeChange = (value) => {
      if (!value) {
        delete state.model.service_cost;
      }
    };
    return {
      state,
      props,
      formDom,
      belongerDom,
      phone_rules,
      passwordlength_rules,
      onAreaChange,
      onLoadIndustry,
      onLoadAreaCode,
      onLoadService,
      onLoadAdmin,
      onSubmit,
      onBelongerChange,
      onServiceCostCalcModeChange,
      onServiceCostTypeChange,
      onSignerChange,
    };
  },
};
</script>
<style scoped lang="less"></style>
